module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    attrs: {
      "id": "content_navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "id": "categories-button"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('div', {
    staticClass: "sprite navigation butt_black right",
    attrs: {
      "title": "Open Menu"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "categories-dropdown"
    }
  }, [_c('div', {
    staticClass: "categories-inside"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/buy'
      }
    }
  }, [_vm._v("Buy Picks")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("Testimonials")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/picks'
      }
    }
  }, [_vm._v("View Picks")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("Blog")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/results'
      }
    }
  }, [_vm._v("Results")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("Contact")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:history.back()"
    }
  }, [_c('div', {
    staticClass: "sprite back butt_black left",
    attrs: {
      "title": "Go Back"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5c37092"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 310
// module chunks = 1